import { Component, OnInit, AfterViewInit } from '@angular/core';
import {OrdersService} from '../../services/orders.service';

declare var $: any;

@Component({
    selector: 'app-orders',
    template: `
      <div fxLayout="row" fxLayoutAlign="center center" class="mat-card-container">
        <mat-card class="card" id="orders-page">
          <mat-card-header class="mat-card__header">
            <mat-card-title>
              <h2>Orders</h2>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>

            <orders-section [orders]="orders" (getOrd)="getOrders($event)"></orders-section>
          </mat-card-content>
        </mat-card>
      </div>
    `,
    styleUrls: ['../atoms/orders-section/orders-section.component.scss']
})
export class AdminOrdersComponent {
    orders: any;
    constructor(private orderService: OrdersService) {}
    getOrders({page, pageSize, value}) {
        this.orderService.getOrders(page, pageSize, value)
          .subscribe(data => this.orders = data);
        //   .subscribe((resp) => {
        //     if (typeof resp.data !== 'undefined') {
        //         this.pages = Math.ceil(Number(resp.total)/ this.pageSize);
        //         this.dataAll = resp;
        //         this.orders = [];
        //         for (let key in resp.data) {
        //             this.orders.push({
        //                 orderRef: resp.data[key].order_number,
        //                 amount: resp.data[key].amount,
        //                 extra_charge: resp.data[key].extra_charge,
        //                 extra_charge_failed: resp.data[key].extra_charge_failed,
        //                 created: resp.data[key].created_at,
        //                 billingAddress: resp.data[key].billing_address,
        //                 canceled_at: resp.data[key].canceled_at == null ? false : true,
        //                 order_id: resp.data[key].id,
        //                 icon: this.find(resp.data[key].status).icon,
        //                 status: this.find(resp.data[key].status).label,
        //                 order-shipments: resp.data[key].order-shipments,
        //                 delivery_address: ( resp.data[key].order-shipments.length > 0 ?
        //                   (resp.data[key].order-shipments[0].delivery_address == null ?
        //                     'null' : resp.data[key].order-shipments[0].delivery_address.address ) : 'null' ),
        //                 pickup_address: ( resp.data[key].order-shipments.length > 0 ?
        //                   (resp.data[key].order-shipments[0].pickup_address == null ?
        //                     'null' : resp.data[key].order-shipments[0].pickup_address.address ) : 'null' )
        //             });
        //         }
        //         this.paginateSet();
        //         let openedOrder = this.shipmentsEnable.indexOf(true);
        //         if (openedOrder > -1) {
        //             this.order-shipments = this.dataAll.data[openedOrder].order-shipments;
        //         }
        //         if (this.pages > 0) {
        //             this.logged = true;
        //           this.isOrder = true;
        //         }
        //         if (this.pages === 0) {
        //           this.logged = true;
        //             this.isOrder = false;
        //         }
        //         this.progress = false;
        //     }
        // });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/orders/orders.component.ts